import React from 'react';
import {ProductContextProvider} from 'contexts/product-context';
import {useSelectIntroHook} from 'components/products/selectintro/SelectIntroHook';
import {useCalculateSelectIntroQuery} from 'query/products/home-safe/selectintro';
import {useSelectIntroOverallResults} from 'components/products/selectintro/SelectIntroOverallResults';
import {API_ROUTES} from 'constants/illustrator';
import {useProductWithRef} from 'hooks/product-ref';

/**
 *
 * The "Select Intro" product, aka "HomeSafe Select Intro", part of the "HomeSafe" products.
 *
 */

const SelectIntro = React.forwardRef(function SelectIntroRender(props, ref) {
  const {product, setRef, ...rest} = props;

  const selectIntroHook = useSelectIntroHook({product});
  const selectIntroQuery = useCalculateSelectIntroQuery({product});
  const selectIntroOverallResults = useSelectIntroOverallResults({product});

  useProductWithRef({
    productDetails: selectIntroHook,
    productResults: selectIntroOverallResults,
    productQuery: selectIntroQuery,
    ref,
    ApiRoute: API_ROUTES.SELECTINTRO,
  });

  return (
    <ProductContextProvider
      productDetails={selectIntroHook}
      productResults={selectIntroOverallResults}
      productQuery={selectIntroQuery}
      product={product}
      {...rest}
    />
  );
});

export default SelectIntro;
